module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-4-c9c27710758a4fee06a31a6f0bfbffca.webp";